<template>
    <div class="watchlist-info" v-if="watchlist">
        <div v-if="collections.length > 0" class="watchlist-info__subheader">
            <div>
                <h2 class="user-page black">
                    <span v-html="$t('WatchListCollections.collections')"></span>
                    <span class="icon-info"
                          v-tooltip="{ content: $t('WatchListCollections.here_you_see_bla_bla'), html: true }"></span>
                </h2>
            </div>
        </div>
        <div v-if="collections.length > 0">
            <WatchListDraggableCollection :collections="filteredCollections" v-if="editable"
                                          v-on:order-changed="onChangeOrderCollections">
                <template v-slot="item">
                    <TotemCollectionItemMosaic
                        :collection="item.collection"
                        :index="item.index"
                        v-on:add-to-remove-list="onAddToRemove"
                        v-on:remove-from-remove-list="onRemoveFromRemove"
                        :editable="editable"
                        :isWatchListItem="true"
                        :isBeingEdited="true"
                    />
                </template>
            </WatchListDraggableCollection>
            <CollectionList :collections="filteredCollections" v-if="!editable">
                <template v-slot="item">
                    <TotemCollectionItemMosaic
                        :collection="item.collection"
                        :index="item.index"
                        :editable="editable"
                        :isWatchListItem="true"
                    />
                </template>
            </CollectionList>
        </div>
    </div>
</template>

<script>
    import CollectionList from 'components/user/items-listings/collectionlist/CollectionList'
    import WatchListDraggableCollection from './WatchListDraggableCollection'
    import expiredCoursesAndCollections from 'components/shared/mixins/expiredCoursesAndCollections'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            WatchListDraggableCollection,
            CollectionList
        },
        props: {
            watchlist: Object,
            showCompleted: Boolean,
            editable: {
                type: Boolean,
                default: false
            },
            showExpiredStudies: Boolean
        },
        mixins: [ expiredCoursesAndCollections ],
        data () {
            return {
                collections: [],
                changedOrderOfCollections: false
            }
        },
        computed: {
            ...mapGetters({
                isCourseCompleted: 'CompletedCourses/isCourseCompleted',
            }),
            filteredCollections () {
                return this.collections.filter(collection => {
                    if (this.showCompleted === false) {
                        const items = collection.items.filter(course => !this.isCourseCompleted(course.id))
                        if (items.length === 0) {
                            return false
                        }
                    }
                    if (this.showExpiredStudies === false) {
                        return !this.isCourseOrCollectionExpired(collection)
                    }
                    return true
                })
            }
        },
        methods: {
            removeElements () {
                this.collections = this.collections.filter(course => !course.toDelete)
            },
            onSaveData () {
                this.changedOrderOfCollections = false
            },
            onWatchListChange (newWatchList) {
                if (newWatchList) {
                    let collections = newWatchList.collections || []
                    this.collections = collections.map(el => ({
                        ...el,
                        toDelete: false
                    }))
                } else {
                    this.collections = []
                }
            },
            onChangeOrderCollections (newList) {
                this.collections = newList
            },
            onAddToRemove (id) {
                let indexCollection = this.collections.findIndex(collection => collection.id)
                if (indexCollection >= 0) {
                    this.$set(this.collections, indexCollection, { ...this.collections[indexCollection], toDelete: true })
                }
            },
            onRemoveFromRemove (id) {
                let indexCollection = this.collections.findIndex(collection => collection.id)
                if (indexCollection >= 0) {
                    this.$set(this.collections, indexCollection, { ...this.collections[indexCollection], toDelete: false })
                }
            },
            getElementsToSave () {
                return this.collections
            }
        },
        watch: {
            watchlist: {
                handler: 'onWatchListChange'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .watchlist-info {
        margin: 0 0 40px;

        &__container {
            display: flex;
            flex-direction: column-reverse;
            position: relative;

            [class*="desktop_x"] & {
                flex-direction: row;
                justify-content: space-between;
            }
        }

        &__subheader {
            position: relative;
            font-size: 2.3rem;
            display: flex;
            margin: 20px 0;
            justify-content: space-between;
            align-items: center;
        }

        .icon-info {
            margin: 0 0 0 12px;
        }

        &__description {
            margin: 0 0 25px;
        }

        &__inputs {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            margin: 0 30px 10px 0;
        }

        &__title {
            margin: 0 0 20px;
            width: auto;
        }

        &__dates {
            display: flex;
            margin: 0 0 20px;
            flex-direction: column;

            [class*="desktop"] & {
                flex-direction: row;
                align-items: center;
            }
        }

        &__dates-label {
            font-size: 1.8rem;
            padding: 0 0 10px 0;

            [class*="desktop"] & {
                padding: 0 10px 0 0;
            }
        }

        &__empty-dates {
            align-self: flex-start;
            margin: 10px 0 0;

            [class*="desktop"] & {
                margin: 0;
            }
        }

        &__buttons {
            display: flex;
            flex-direction: column;
            margin: 0 0 20px;

            > button {
                align-self: flex-start;
                margin: 0 0 10px;
            }

            [class*="desktop"] & {
                flex-direction: row;
                > button {
                    margin: 0 10px 0 0;
                }
            }

            [class*="desktop_x"] & {
                > button {
                    margin: 0 0 0 10px
                }
            }
        }

        .toggle-button {
            max-width: 100%;
        }
    }
</style>
